import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import PropTypes from 'prop-types';

const Input = ({
  variant = 'standard',
  label = '',
  helperText,
  error = false,
  width = '200px',
}) => {
  // variant are of types: outlined, filled, standard
  const [value, setValue] = useState('');
  return (
    <FormControl variant="standard">
      <TextField
        label={label}
        variant={variant}
        error={error}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        sx={{ width }}
      />
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  );
};

Input.propTypes = {
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  label: PropTypes.string,
  helperText: PropTypes.node,
  error: PropTypes.bool,
  width: PropTypes.string,
};

export default Input;
